import { GraphqlResolverInput, QueryListResponse, SelectOption } from 'global';
import { useQuery } from '@apollo/client';
import { GET_REGIONS } from '../api/dictionaries';
import { DealSheetAPINameSpase } from '../../dealSheet/types';

export const useRegions = (country: string = 'US') => {
  const { data, loading } = useQuery<
    DealSheetAPINameSpase<QueryListResponse<SelectOption>>,
    GraphqlResolverInput<{ country: string }>
  >(GET_REGIONS, {
    skip: !country,
    variables: {
      input: {
        country,
      },
    },
  });
  return {
    loading,
    regions: data?.dealSheet?.result?.list ?? [],
  };
};
